var React = require('react');

function MenuArrowNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.18994 6C8.18994 6.3089 8.06308 6.60375 7.84002 6.81328L2.63072 11.7065C2.18933 12.1211 1.50121 12.0931 1.09377 11.6439C0.686334 11.1948 0.713859 10.4945 1.15525 10.0799L5.49874 6L1.15525 1.92008C0.713859 1.50547 0.686334 0.805244 1.09377 0.356084C1.50121 -0.0930769 2.18933 -0.121086 2.63072 0.293524L7.84002 5.18672C8.06308 5.39625 8.18994 5.6911 8.18994 6Z","fill":"#191C1F"}));
}

MenuArrowNext.defaultProps = {"width":"9","height":"12","viewBox":"0 0 9 12","fill":"none"};

module.exports = MenuArrowNext;

MenuArrowNext.default = MenuArrowNext;
